import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-packaging-confirmation',
  templateUrl: './packaging-confirmation.component.html',
  styleUrls: ['./packaging-confirmation.component.css']
})
export class PackagingConfirmationComponent implements OnInit {
  @Input()
  dataForUpdate;

  constructor(
    public activeModal: NgbActiveModal
  ) { }

  ngOnInit() {
  }

  get getChanges(){
    return `${this.dataForUpdate.quantityInTotal}/${this.dataForUpdate.quantityInSheet}`
  }

  confirmChanges(){
    this.activeModal.dismiss({
      confirm: true
    })
  }

}
